import { render, staticRenderFns } from "./dqs.vue?vue&type=template&id=066eb872"
import script from "./dqs.vue?vue&type=script&lang=js"
export * from "./dqs.vue?vue&type=script&lang=js"
import style0 from "./dqs.vue?vue&type=style&index=0&id=066eb872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports